import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthLayout from "./routes/middleware/AuthLayout";
import NonAuthLayout from "./routes/middleware/NonAuthLayout";
import { authRoutes, nonAuthRoutes, userRoutes } from "./routes/AllRoutes";
import UserLayout from "./routes/middleware/UserLayout";
import AuthProvider from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import "aos/dist/aos.css";
import AOS from "aos";
import { AppProvider } from "./context/AppContext";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      offset: 80, // trigger animations earlier/later
    });
    AOS.refreshHard();
  }, []);

  // Renders authenticated routes
  const renderAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<AuthLayout>{route.component}</AuthLayout>}
      />
    ));
  };

  // Renders non-authenticated routes
  const renderNonAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<NonAuthLayout>{route.component}</NonAuthLayout>}
      />
    ));
  };

  const renderUserRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<UserLayout>{route.component}</UserLayout>}
      />
    ));
  };

  return (
    <React.Fragment>
      <BrowserRouter>
        <AppProvider>
          <AuthProvider>
            <div>
              <Routes>
                {renderNonAuthRoutes(nonAuthRoutes)}
                {renderAuthRoutes(authRoutes)}
                {renderUserRoutes(userRoutes)}
              </Routes>
              <Toaster></Toaster>
            </div>
          </AuthProvider>
        </AppProvider>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
